var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2149_2242",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2149_2242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.75 6.7314v-3.6689c0-0.11603 0.04609-0.22731 0.12814-0.30936 0.08204-0.08205 0.19332-0.12814 0.30936-0.12814 0.11603 0 0.22731 0.04609 0.30936 0.12814 0.08204 0.08205 0.12814 0.19333 0.12814 0.30936v5.25c0 0.11603-0.0461 0.22731-0.12814 0.30936-0.08205 0.08205-0.19333 0.12814-0.30936 0.12814h-5.25c-0.116 0-0.2273-0.04609-0.3094-0.12814-0.082-0.08205-0.1281-0.19333-0.1281-0.30936s0.0461-0.22731 0.1281-0.30936c0.0821-0.08205 0.1934-0.12814 0.3094-0.12814h4.592c-1.9057-2.6495-5.0164-4.375-8.5295-4.375-5.7986 0-10.5 4.7014-10.5 10.5 0 5.7986 4.7014 10.5 10.5 10.5 5.7986 0 10.5-4.7014 10.5-10.5 0-0.42-0.02421-0.8339-0.07263-1.2416-8e-3 -0.063-0.0026-0.127 0.01578-0.1878 0.01841-0.0608 0.04944-0.117 0.09106-0.165s0.0929-0.0866 0.15048-0.1135c0.05758-0.0268 0.12017-0.0411 0.18368-0.0421 0.10352-9e-4 0.20377 0.0362 0.28181 0.1043 0.07803 0.068 0.12843 0.1623 0.14169 0.265 0.05569 0.4581 0.08345 0.9192 0.08313 1.3807 0 6.2825-5.0925 11.375-11.375 11.375-6.2825 0-11.375-5.0925-11.375-11.375s5.0925-11.375 11.375-11.375c3.5175 0 6.6631 1.5969 8.75 4.1064z",
    fill: "currentColor"
  }))));
};
export default SvgRefresh;